import { useSelector, useDispatch } from 'react-redux';
import {
  setConversationHistory,
  addToConversationHistory,
  setCurrentScriptSection,
  setCurrentStepIndex,
  setSearchTerm,
  setIsInitialized,
  setCollectedInfo,
  resetSupportDesk,
  initializeDefaultChat,
} from '../slices/supportDeskSlice';

export const useSupportDesk = () => {
  const dispatch = useDispatch();
  const supportDeskState = useSelector((state) => state.supportDesk);

  const actions = {
    setConversationHistory: (history) => dispatch(setConversationHistory(history)),
    addToConversationHistory: (message) => dispatch(addToConversationHistory(message)),
    setCurrentScriptSection: (section) => dispatch(setCurrentScriptSection(section)),
    setCurrentStepIndex: (index) => dispatch(setCurrentStepIndex(index)),
    setSearchTerm: (term) => dispatch(setSearchTerm(term)),
    setIsInitialized: (initialized) => dispatch(setIsInitialized(initialized)),
    setCollectedInfo: (info) => dispatch(setCollectedInfo(info)),
    resetSupportDesk: () => dispatch(resetSupportDesk()),
    initializeDefaultChat: (chatData) => dispatch(initializeDefaultChat(chatData)),
  };

  return {
    ...supportDeskState,
    ...actions,
  };
};